// src/mathHelpers.ts
function getRandomDecimal() {
  if (typeof window !== "undefined" && window.crypto) {
    const randomBuffer = new Uint32Array(1);
    window.crypto.getRandomValues(randomBuffer);
    return randomBuffer[0] / (4294967295 + 1);
  }
  return Math.random();
}
function getWeightedRandomNumber(spec) {
  let i;
  let sum = 0;
  const r = getRandomDecimal();
  for (i in spec) {
    sum += spec[i];
    if (r <= sum)
      break;
  }
  return i;
}
function getDefaultWeights(variants) {
  return Array.from({ length: variants.length }).fill(1 / variants.length);
}
function validateWeights(variants, weights) {
  const sum = weights == null ? void 0 : weights.reduce((acc, weight) => acc + weight, 0);
  return weights != null && sum === 1 && variants.length === weights.length ? weights : getDefaultWeights(variants);
}
function getWeightedRandomVariant(variants, weights) {
  const validatedWeights = validateWeights(variants, weights);
  return getWeightedRandomNumber(
    variants.reduce(
      (acc, variant, index) => {
        acc[variant] = validatedWeights[index];
        return acc;
      },
      {}
    )
  );
}
function getVariantWithHeighestWeightOrFirst(variants, weights) {
  const validatedWeights = validateWeights(variants, weights);
  let variantWithHeighestWeight = variants[0];
  for (let i = 1; i < variants.length; i++) {
    if (validatedWeights[i] > validatedWeights[i - 1]) {
      variantWithHeighestWeight = variants[i];
    }
  }
  return variantWithHeighestWeight;
}

export { getVariantWithHeighestWeightOrFirst, getWeightedRandomVariant, validateWeights };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-5AXMGLYW.mjs.map